class Role {
  constructor({ role }) {
    this.role = role;
  }
}

export default Role;
